export default "assets/images/properties-bg-b2feee7f.svg";